import Loadable from 'react-loadable'
import 'monaco-editor/esm/vs/base/browser/ui/codicons/codicon/codicon.css'

const LoadableMonacoEditor = Loadable({
  loader: () => import('react-monaco-editor'),
  loading: () => null
})

export default LoadableMonacoEditor
